import { cmsApi } from "../../utils/api";
import utils from "../../utils/commonFunctions";

// #################################
//          PROJECTS API FUNCTIONS
// #################################

// Fetch All LabServiceProducts
export const fetchAllProjects = async (pageNumber = 1, pageSize = 10, filterOptions = {}) => {
    try {
        const queryParams = new URLSearchParams({
            ...filterOptions,
            pageNumber,
            pageSize
        }).toString();

        const response = await cmsApi.get(`/projects?${queryParams}`);

        if (response.status === 200) {
            const { docs: projects, totalDocs } = response.data;
            return {
                projects: response.data,
                totalPages: Math.ceil(totalDocs / pageSize),
            };
        } else {
            throw new Error('Unexpected response from the server while fetching projects.');
        }
    } catch (error) {
        utils.sendMessageToBugNinja("Error while fetching project data:", error.message, error)
        throw new Error('Failed to fetch projects. Please try again.');
    }
};

// addProject API
export const addProject = async (projectData) => {
    try {
        // The add form passes a JSON string; normalise to an object before posting.
        const data = typeof projectData === 'string' ? JSON.parse(projectData) : projectData;
        const response = await cmsApi.post(`/projects`, data);
        if (response.status === 201) {
            return response.data;
        } else {
            throw new Error('Unexpected response from the server while adding project.');
        }
    } catch (error) {
        utils.sendMessageToBugNinja("Error while adding project data:", error.message, error)
        throw new Error('Failed to add project. Please try again.');
    }
};

// fetch projects by id
export const fetchProjectById = async (projectId) => {
    try {
        const response = await cmsApi.get(`/projects/${projectId}`);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response from the server while fetching project.');
        }
    } catch (error) {
        utils.sendMessageToBugNinja("Error while fetching project data by id:", error.message, error)
        throw new Error('Failed to fetch project. Please try again.');
    }
};

// update project API
export const updateProject = async (projectId, projectData) => {
    try {
        console.log("projectData", projectData);
        console.log("projectId", projectId);
        const data = typeof projectData === 'string' ? JSON.parse(projectData) : projectData;
        const response = await cmsApi.put(`/projects/${projectId}`, data);

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response from the server while updating project.');
        }
    } catch (error) {
        utils.sendMessageToBugNinja("Error while updating project data:", error.message, error)
        throw new Error('Failed to update project. Please try again.');
    }
};

// delete project by ID API
export const deleteProject = async (projectId) => {
    try {
        const response = await cmsApi.delete(`/projects/${projectId}`);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Unexpected response from the server while deleting project.');
        }
    } catch (error) {
        utils.sendMessageToBugNinja("Error while deleting project data:", error.message, error)
        throw new Error('Failed to delete project. Please try again.');
    }
};
